import { useShouldShowAgentsTab } from "@circle-react/components/SettingsApp/CommunityInbox/hooks/useShouldShowAgentsTab";
import { useCommunityFeatureFlagsContext } from "@circle-react/contexts/communityFeatureFlagsContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";

// messaging_enabled here refers to output of model level method `messaging_enabled?` and not the column in the database.
// It considers the community and community member level settings to determine if messaging is enabled for the user.
export const useIsMessagingEnabled = () => {
  const { currentCommunityMember } = usePunditUserContext();
  return Boolean(currentCommunityMember?.messaging_enabled || false);
};

export const useIsCommunityMemberGroupMessagingEnabled = () => {
  const {
    record: { group_messaging_enabled: communityGroupMessagingEnabled },
  } = useCommunityFeatureFlagsContext();

  const { currentCommunityMember } = usePunditUserContext();

  const {
    messaging_enabled: isMessagingEnabled = false,
    messaging_enabled_by_admin: isMessagingEnabledByAdmin = false,
    messaging_enabled_by_member: isMessagingEnabledByMember = false,
  } = currentCommunityMember || {};

  return (
    communityGroupMessagingEnabled &&
    isMessagingEnabled &&
    isMessagingEnabledByAdmin &&
    isMessagingEnabledByMember
  );
};

export const useIsMemberToMemberMessagingEnabledOrAdmin = () => {
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  const isMemberMessagingEnabled = Boolean(
    currentCommunitySettings?.messaging_settings
      ?.member_to_member_messaging_enabled,
  );

  return isAdmin || isMemberMessagingEnabled;
};

export const useShouldShowMessagingRoutes = () => {
  const { currentCommunityMember, isLoading } = usePunditUserContext();

  // If the member can access direct messages tab
  const hasMessagesTab =
    !!currentCommunityMember?.policies?.can_access_direct_messages;

  const shouldShowAgentsTab = useShouldShowAgentsTab({
    enabled: !isLoading && !!currentCommunityMember && !hasMessagesTab,
  });

  //shouldShowMessagingRoutes: display messaging specific routes on the app.
  //showMessagesTab: display messaging tab like inbox, unread on the app.
  return {
    shouldShowMessagingRoutes: Boolean(shouldShowAgentsTab || hasMessagesTab),
    showMessagesTab: hasMessagesTab,
  };
};
